/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Meta_TitleInputs */

const en_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact | Mark Egly Golf | 515-289-1703`)
};

const es_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacto | Mark Egly Golf | 515-289-1703`)
};

const de_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt | Mark Egly Golf | 515-289-1703`)
};

const zh_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系我们 | Mark Egly Golf | 515-289-1703`)
};

const ar_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل معنا | Mark Egly Golf | 515-289-1703`)
};

const fr_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacter | Mark Egly Golf | 515-289-1703`)
};

const vi_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên hệ | Mark Egly Golf | 515-289-1703`)
};

const sw_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wasiliana | Mark Egly Golf | 515-289-1703`)
};

const th_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดต่อ | Mark Egly Golf | 515-289-1703`)
};

const bs_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt | Mark Egly Golf | 515-289-1703`)
};

const ja_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ | Mark Egly Golf | 515-289-1703`)
};

const ko_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연락처 | Mark Egly Golf | 515-289-1703`)
};

const pt_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contato | Mark Egly Golf | 515-289-1703`)
};

const it_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatti | Mark Egly Golf | 515-289-1703`)
};

const sv_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt | Mark Egly Golf | 515-289-1703`)
};

const nl_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact | Mark Egly Golf | 515-289-1703`)
};

const da_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt | Mark Egly Golf | 515-289-1703`)
};

const nb_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt | Mark Egly Golf | 515-289-1703`)
};

const fi_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteystiedot | Mark Egly Golf | 515-289-1703`)
};

const pl_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt | Mark Egly Golf | 515-289-1703`)
};

const ru_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контакты | Mark Egly Golf | 515-289-1703`)
};

const tr_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İletişim | Mark Egly Golf | 515-289-1703`)
};

const hi_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपर्क | Mark Egly Golf | 515-289-1703`)
};

const id_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontak | Mark Egly Golf | 515-289-1703`)
};

const ms_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi | Mark Egly Golf | 515-289-1703`)
};

const cs_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt | Mark Egly Golf | 515-289-1703`)
};

const el_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επικοινωνία | Mark Egly Golf | 515-289-1703`)
};

const he_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צרו קשר | Mark Egly Golf | 515-289-1703`)
};

const af_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontak | Mark Egly Golf | 515-289-1703`)
};

const hu_contact_meta_title = /** @type {(inputs: Contact_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapcsolat | Mark Egly Golf | 515-289-1703`)
};

/**
* | output |
* | --- |
* | "Contact \| Mark Egly Golf \| 515-289-1703" |
*
* @param {Contact_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_meta_title = /** @type {((inputs?: Contact_Meta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Meta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_meta_title(inputs)
	if (locale === "de") return de_contact_meta_title(inputs)
	if (locale === "zh") return zh_contact_meta_title(inputs)
	if (locale === "ar") return ar_contact_meta_title(inputs)
	if (locale === "fr") return fr_contact_meta_title(inputs)
	if (locale === "vi") return vi_contact_meta_title(inputs)
	if (locale === "sw") return sw_contact_meta_title(inputs)
	if (locale === "th") return th_contact_meta_title(inputs)
	if (locale === "bs") return bs_contact_meta_title(inputs)
	if (locale === "ja") return ja_contact_meta_title(inputs)
	if (locale === "ko") return ko_contact_meta_title(inputs)
	if (locale === "pt") return pt_contact_meta_title(inputs)
	if (locale === "it") return it_contact_meta_title(inputs)
	if (locale === "sv") return sv_contact_meta_title(inputs)
	if (locale === "nl") return nl_contact_meta_title(inputs)
	if (locale === "da") return da_contact_meta_title(inputs)
	if (locale === "nb") return nb_contact_meta_title(inputs)
	if (locale === "fi") return fi_contact_meta_title(inputs)
	if (locale === "pl") return pl_contact_meta_title(inputs)
	if (locale === "ru") return ru_contact_meta_title(inputs)
	if (locale === "tr") return tr_contact_meta_title(inputs)
	if (locale === "hi") return hi_contact_meta_title(inputs)
	if (locale === "id") return id_contact_meta_title(inputs)
	if (locale === "ms") return ms_contact_meta_title(inputs)
	if (locale === "cs") return cs_contact_meta_title(inputs)
	if (locale === "el") return el_contact_meta_title(inputs)
	if (locale === "he") return he_contact_meta_title(inputs)
	if (locale === "af") return af_contact_meta_title(inputs)
	if (locale === "hu") return hu_contact_meta_title(inputs)
	return en_contact_meta_title(inputs)
});